import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BufferContent} from 'buffers/BufferComps';
import {BufferViewType} from 'buffers/BufferTypes';
import {DiffDetails} from 'molbio/biointelligent-links/replace-link/constants';
import PaneWithSidebar from 'molbio/biointelligent-links/replace-link/PaneWithSidebar';
import {SimplifiedSequenceAlignmentTabOptionsView} from 'molbio/biointelligent-links/replace-link/SimplifiedSequenceAlignmentTabOptionsView';
import useTransientSequenceAlignmentTabState from 'molbio/biointelligent-links/replace-link/useTransientSequenceAlignmentTabState';
import SequenceAlignmentTabView from 'molbio/maps/alignment/SequenceAlignmentTabView';
import {FONT_PROXIMA_14} from 'styles/FontConstants';
import {InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

export interface ReviewEditsPaneProps {
  referenceSequenceId: string;
  diffDetails: DiffDetails | null;
  sidebarExpanded: boolean;
  onToggleSidebarExpanded: () => void;
}

function ReviewEditsPane(props: ReviewEditsPaneProps): JSX.Element {
  const tabState = useTransientSequenceAlignmentTabState(props.referenceSequenceId, props.diffDetails);

  return (
    <PaneWithSidebar
      sidebarExpanded={props.sidebarExpanded}
      onToggleSidebarExpanded={props.onToggleSidebarExpanded}
      sidebarContent={
        <>
          <p className={css(styles.helpText)}>
            Review edits made to the updated sequence compared to the original sequence you intend to replace
          </p>
          <InlineBannerStack
            messages={[
              {
                bannerType: InlineBannerType.INFO,
                text: 'MAFFT is used to perform a global pairwise alignment to identify sequence edits between reference and modified sequences',
              },
            ]}
          />
        </>
      }
    >
      <div className="reset">
        <div id="buffers" className={css(styles.buffers)}>
          <div className="buffer-container">
            <BufferContent
              tabState={tabState}
              tabContentMetadata={{TabView: SequenceAlignmentTabView, tabViewType: BufferViewType.BACKBONE}}
              tabOptionsMetadata={{
                OptionsView: SimplifiedSequenceAlignmentTabOptionsView,
                optionsViewType: BufferViewType.BACKBONE,
              }}
            />
          </div>
        </div>
      </div>
    </PaneWithSidebar>
  );
}

const styles = StyleSheet.create({
  helpText: {
    ...FONT_PROXIMA_14,
    marginBottom: '24px',
  },
  buffers: {
    // Usually there is space reserved for the statusbar and toolbar, so override that.
    bottom: '0',
    right: '0',
    height: '100%',
  },
});

export default React.memo(ReviewEditsPane);
